var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2099_410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 0C8.26517 0 8.51953 0.105368 8.70707 0.292906C8.89461 0.480411 8.99994 0.734774  8.99994 0.999994V6.99995H14.9998C15.2651 6.99995 15.5195 7.10532 15.707 7.29286C15.8944 7.4804  16 7.73473 16 7.99995C16 8.26517 15.8944 8.51953 15.707 8.70707C15.5195 8.89461 15.2651 8.99994  14.9998 8.99994H8.99994V14.9999C8.99994 15.2652 8.89461 15.5196 8.70707 15.7071C8.51953 15.8945  8.26517 15.9998 7.99995 15.9998C7.73473 15.9998 7.4804 15.8945 7.29286 15.7071C7.10532 15.5196   6.99996 15.2652 6.99996 14.9999V8.99994H0.999994C0.734774 8.99994 0.480411 8.89461 0.292873   8.70707C0.105368 8.51953 0 8.26517 0 7.99995C0 7.73473 0.105368 7.4804 0.292873 7.29286C0.480411   7.10532 0.734774 6.99995 0.999994 6.99995H6.99996V0.999994C6.99996 0.734774 7.10532 0.480411 7.29286   0.292906C7.4804 0.105368 7.73473 0 7.99995 0Z",
    fill: "#261F53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2099_410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/AddNew.f47846816985f03f2a4c41ac013cf3f8.svg";
export { ForwardRef as ReactComponent };